module.exports = __webpack_public_path__ + "static/media/cbs-tv-shows-top.45b20ccf.png";